module.exports = "/_next/static/images/Hero-e72464ae198523054f2f10888dab8628.webp";